import { render } from "./ProductsGridPage.vue?vue&type=template&id=7989e58a&ts=true"
import script from "./ProductsGridPage.vue?vue&type=script&lang=ts"
export * from "./ProductsGridPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__